import { ERROR_CONSTANTS as ERROR } from './error.constants';

export const ERROR_MAPPING = {
  [ERROR.ERRORS.MESSAGE_BACKEND.DEFAULT]: ERROR.ERRORS.MESSAGE_FRONTEND.DEFAULT,

  [ERROR.ERRORS.MESSAGE_BACKEND.EMAIL_EXIST]: ERROR.ERRORS.MESSAGE_FRONTEND.EMAIL_EXIST,

  [ERROR.ERRORS.MESSAGE_BACKEND.EXIST_PHONE_NUMBER]:
    ERROR.ERRORS.MESSAGE_FRONTEND.EXIST_PHONE_NUMBER,

  [ERROR.ERRORS.MESSAGE_BACKEND.CODE_NO_EXISTS]: ERROR.ERRORS.MESSAGE_FRONTEND.CODE_NO_EXISTS,

  [ERROR.ERRORS.MESSAGE_BACKEND.CORS]: ERROR.ERRORS.MESSAGE_FRONTEND.CORS,
  [ERROR.ERRORS.MESSAGE_BACKEND.DEBIT_CARD]: ERROR.ERRORS.MESSAGE_FRONTEND.DEBIT_CARD,
  [ERROR.ERRORS.MESSAGE_BACKEND.CUSTOMER_EXISTS]: ERROR.ERRORS.MESSAGE_FRONTEND.CUSTOMER_EXISTS,
  [ERROR.ERRORS.MESSAGE_BACKEND.ERROR_1003_TOKEN_ID_DOESNT_EXIST]:
    ERROR.ERRORS.MESSAGE_FRONTEND.ERROR_1003_TOKEN_ID_DOESNT_EXIST,
  [ERROR.ERRORS.MESSAGE_BACKEND.ERROR_1550_INVALID_CODE]:
    ERROR.ERRORS.MESSAGE_FRONTEND.ERROR_1550_INVALID_CODE,
  [ERROR.ERRORS.MESSAGE_BACKEND.ERROR_1550_INVALID_CARD]:
    ERROR.ERRORS.MESSAGE_FRONTEND.ERROR_1550_INVALID_CARD,
  [ERROR.ERRORS.MESSAGE_BACKEND.ERROR_1550_CARD_BLOCKED]:
    ERROR.ERRORS.MESSAGE_FRONTEND.ERROR_1550_CARD_BLOCKED,
  [ERROR.ERRORS.MESSAGE_BACKEND.ERROR_1550_MERCHANT_ID_INVALID]:
    ERROR.ERRORS.MESSAGE_FRONTEND.ERROR_1550_MERCHANT_ID_INVALID,
  [ERROR.ERRORS.MESSAGE_BACKEND.ERROR_2011_TYPE_NOT_SUPPORTED]:
    ERROR.ERRORS.MESSAGE_FRONTEND.ERROR_2011_TYPE_NOT_SUPPORTED,
  [ERROR.ERRORS.MESSAGE_BACKEND.ERROR_3001_CARD_DECLINED_BY_BANK]:
    ERROR.ERRORS.MESSAGE_FRONTEND.ERROR_3001_CARD_DECLINED_BY_BANK,
  [ERROR.ERRORS.MESSAGE_BACKEND.ERROR_3002_CARD_EXPIRED]:
    ERROR.ERRORS.MESSAGE_FRONTEND.ERROR_3002_CARD_EXPIRED,
  [ERROR.ERRORS.MESSAGE_BACKEND.ERROR_3003_INSUFFICIENT_FUNDS]:
    ERROR.ERRORS.MESSAGE_FRONTEND.ERROR_3003_INSUFFICIENT_FUNDS,
};
